/*
  example:
    import { getPhoto } from '@/services/WorkOrderRequests/WorkOrderRequestPhoto/GetPhotoFile';

    const { photo, successful, message } = await getPhoto ({
      params: {
        workOrderRequestPhotoID: 

        // optional
        asBase64: true,
        scaleToWidth: 
        scaleToHeight: 
      }
    });
    if (!successful) {
      console.error (message);
      return;
    }
*/
//
import kms from '@/services/kms'
//
export async function getPhoto({ params, kms: kms_ = kms } = {}) {
  let message = `A photo could not be retrieved.`

  console.log({ params })

  try {
    const result = await kms_.get(`/WorkOrderRequests/WorkOrderRequestPhoto/GetPhotoFile`, {
      params
    })

    return {
      successful: true,
      message: '',
      photo: result
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    photo: null
  }
}

///////
